import styled, { css } from 'styled-components';
import {
  Row, Column, mediaCSS,
} from '@web-packages/library/layouts';
import colors from '@shared/design-tokens/colors';
import types from './types';

const infoIconWrapperTabletAndUpCSS = {
  stroke: colors.white,
  width: '5%',
  display: 'flex',
  order: '1',
  minWidth: '80px',
  fontSize: '37px',
  justifyContent: 'center',
  alignItems: 'center',
};

const crossIconWrapperTabletAndUpCSS = {
  order: '3',
  minWidth: '80px',
  justifyContent: 'center',
  alignItems: 'center',
};

const infoTextWrapperTabletAndUpCSS = {
  width: '95%',
  marginTop: '0',
  order: '2',
};

/** styled-components */
const backgroundTypes = {};
backgroundTypes[types.infoMessage] = colors.announcement.info;
backgroundTypes[types.warningMessage] = colors.announcement.warning;
const getColorBasedOnType = (type) => (backgroundTypes[type]);

const crossIconStyle = css`
  width: 5%;
  order: 2;
  align-items: center;
  padding: 0 5px 0 25px;
  ${mediaCSS.tablet(crossIconWrapperTabletAndUpCSS)}
`;

const announcementTypeIconStyle = css`
  display: none;
  ${mediaCSS.tablet(infoIconWrapperTabletAndUpCSS)}
`;

export const Wrapper = styled(Row)`
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  padding: 20px;
  border-radius: 0 0 10px 10px;
  z-index: 1301;
  justify-content: space-between;

  ${({ type }) => (type
    && { 'background-color': getColorBasedOnType(type) }
  )}

  .close-announcement-icon {
    ${crossIconStyle}
    ${mediaCSS.maxWidthTablet({ 'justify-content': 'flex-end' })}
  }
  .announcement-type-icon {
    ${announcementTypeIconStyle}
  }
`;

export const InfoText = styled(Column)`
  p {
    color: ${colors.white}
  }
  order: 1;
  width: 80%;
  margin-top: 5px;
  ${mediaCSS.tablet(infoTextWrapperTabletAndUpCSS)}
`;
